import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import { useOpenableControls } from '../../../../generic-hooks'
import { NOW_LABEL } from '../../../../now'
import { useProductSearchResultItemContext } from '../ProductSearchResultItemContext/productSearchResultItemContext'
import { ProductSearchResultItemNowDialog } from '../ProductSearchResultItemNowDialog'

import { ProductSearchResultItemGenericLabel } from './ProductSearchResultItemGenericLabel'

export const ProductSearchResultItemNowLabel: FC = () => {
  const modalControls = useOpenableControls()
  const { nowDetails } = useProductSearchResultItemContext()

  return (
    <>
      <ProductSearchResultItemGenericLabel
        className="border-light-primary-strong bg-light-primary-medium capitalize"
        data-qa-id="form-now-modal-button"
        onClick={modalControls.handleOpen}
      >
        {nowDetails.nowCustomerJourneyEnabled ? (
          <FormattedMessage id="product.label.nowProductGroup" />
        ) : (
          <span>{NOW_LABEL}</span>
        )}
      </ProductSearchResultItemGenericLabel>

      <ProductSearchResultItemNowDialog
        isOpen={modalControls.isOpen}
        onClose={modalControls.handleClose}
      />
    </>
  )
}
